import Vue from "vue";
import Vuex from "vuex";
const fb = require("./firebaseConfig.js");

Vue.use(Vuex);

// handle page reload
fb.auth.onAuthStateChanged((user) => {
  if (user) {
    store.commit("setCurrentUser", user);
    store.dispatch("fetchUserProfile");
    store.dispatch("fetchUserProfileDetails");
    store.commit("setUserProfile", fb.auth.currentUser);
  }
});

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    tiles: [],
    functionality: [],
    hiddenPosts: [],
    keywords: [],
    messages: [],
    tov: [],
    archetypes: [],
    exProposition: [],
    userProfileDetails: {},
    currentProject: "",
    currentProjectModel: {},
    currentExercises: [],
    currentPlanes: [],
    exTiles: [],
    exTravel: [],
    exFly: [],
    exTov: [],
    exFunctionality: [],
    exKeywords: [],
    exMessages: [],
    exArchetypes: [],
    exArchetypesSummary: [],
    exPersonas: [],
    exTypes: [],
    exTraffic: [],
    exProblem: [],
    exEmpathy: [],
    exIsInIf: [],
    exBlocks: [],
    colors: [
      { title: "red", className: "red white--text" },
      { title: "pink", className: "pink white--text" },
      { title: "purple", className: "purple white--text" },
      { title: "deep purple", className: "deep-purple white--text" },
      { title: "indigo", className: "indigo white--text" },
      { title: "blue", className: "blue white--text" },
      { title: "light blue", className: "light-blue black--text" },
      { title: "cyan", className: "cyan black--text" },
      { title: "teal", className: "teal white--text" },
      { title: "green", className: "green white--text" },
      { title: "light green", className: "light-green white--text" },
      { title: "lime", className: "lime black--text" },
      { title: "yellow", className: "yellow black--text" },
      { title: "amber", className: "amber white--text" },
      { title: "orange", className: "orange black--text" },
      { title: "deep orange", className: "deep-orange white--text" },
      { title: "brown", className: "brown white--text" },
      { title: "grey", className: "blue-grey white--text" },
    ],
  },
  actions: {
    clearData({ commit }) {
      commit("setCurrentUser", null);
      commit("setUserProfile", {});
      commit("setUserProfileDetails", {});
      commit("setTiles", null);
      commit("setFunctionality", null);
      commit("setHiddenPosts", null);
    },
    fetchUserProfile({ commit }) {
      commit("setUserProfile", fb.auth.currentUser);
    },
    fetchUserProfileDetails({ commit }) {
      fb.profilesCollection
        .where("uid", "==", fb.auth.currentUser.uid)
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            commit("setUserProfileDetails", items[0]);
          }
        })
        .catch(function() {});
    },
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val;
    },
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setCurrentProject(state, val) {
      state.currentProject = val;
    },
    setCurrentProjectModel(state, val) {
      state.currentProjectModel = val;
    },
    setCurrentExercises(state, val) {
      state.currentExercises = val;
    },
    setCurrentPlanes(state, val) {
      state.currentPlanes = val || [];
    },
    setUserProfileDetails(state, val) {
      state.userProfileDetails = val;
    },
    setTiles(state, val) {
      if (val) {
        state.tiles = [];
        state.tiles = val;
      } else {
        state.tiles = [];
      }
    },
    setArchetypes(state, val) {
      if (val) {
        state.archetypes = val;
      } else {
        state.archetypes = [];
      }
    },
    setFunctionality(state, val) {
      if (val) {
        state.functionality = val;
      } else {
        state.functionality = [];
      }
    },
    setKeywords(state, val) {
      if (val) {
        state.keywords = val;
      } else {
        state.keywords = [];
      }
    },
    setMessages(state, val) {
      if (val) {
        state.messages = val;
      } else {
        state.messages = [];
      }
    },
    setProposition(state, val) {
      if (val) {
        state.proposition = val;
      } else {
        state.proposition = [];
      }
    },
    setTov(state, val) {
      if (val) {
        state.tov = val;
      } else {
        state.tov = [];
      }
    },
    setExIsInIf(state, val) {
      if (val) {
        state.exIsInIf = val;
      } else {
        state.exIsInIf = [];
      }
    },
    setExBlocks(state, val) {
      if (val) {
        state.exBlocks = val;
      } else {
        state.exBlocks = [];
      }
    },
    setExTiles(state, val) {
      if (val) {
        state.exTiles = val;
      } else {
        state.exTiles = [];
      }
    },
    setExPersonas(state, val) {
      if (val) {
        state.exPersonas = val;
      } else {
        state.exPersonas = [];
      }
    },
    setExProblem(state, val) {
      if (val) {
        state.exProblem = val;
      } else {
        state.exProblem = [];
      }
    },
    setExArchetypes(state, val) {
      if (val) {
        state.exArchetypes = val;
      } else {
        state.exArchetypes = [];
      }
    },
    setExArchetypesSummary(state, val) {
      if (val) {
        state.exArchetypesSummary = val;
      } else {
        state.exArchetypesSummary = [];
      }
    },
    setExTypes(state, val) {
      if (val) {
        state.exTypes = val;
      } else {
        state.exTypes = [];
      }
    },
    setExTraffic(state, val) {
      if (val) {
        state.exTraffic = val;
      } else {
        state.exTraffic = [];
      }
    },
    setExTravel(state, val) {
      if (val) {
        state.exTravel = val;
      } else {
        state.exTravel = [];
      }
    },
    setExFly(state, val) {
      if (val) {
        state.exFly = val;
      } else {
        state.exFly = [];
      }
    },
    setExEmpathy(state, val) {
      if (val) {
        state.exEmpathy = val;
      } else {
        state.exEmpathy = [];
      }
    },
    setExFunctionality(state, val) {
      if (val) {
        state.exFunctionality = val;
      } else {
        state.exFunctionality = [];
      }
    },
    setExKeywords(state, val) {
      if (val) {
        state.exKeywords = val;
      } else {
        state.exKeywords = [];
      }
    },
    setExMessages(state, val) {
      if (val) {
        state.exMessages = val;
      } else {
        state.exMessages = [];
      }
    },
    setExProposition(state, val) {
      if (val) {
        state.exProposition = val;
      } else {
        state.exProposition = [];
      }
    },
    setExTov(state, val) {
      if (val) {
        state.exTov = val;
      } else {
        state.exTov = [];
      }
    },
    setHiddenPosts(state, val) {
      if (val) {
        if (!state.hiddenPosts.some((x) => x.id === val.id)) {
          state.hiddenPosts.unshift(val);
        }
      } else {
        state.hiddenPosts = [];
      }
    },
  },
});
